import { ThemeProvider } from '@workboard/wobo-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '../ErrorBoundary';

import { GlobalConfigProvider } from '../global/ConfigProvider';
import { ToastNotificationProvider } from '../notifications';
import { getFeatureFlag } from '../utils/getFeatureFlag';
import { AICopyStandaloneDialog } from './standaloneDialog';
import { FormData } from './useCopyAIForm';

export * from './standaloneDialog';

export const aiCopyAndLink = (id: string, initialData?: Partial<FormData>) => {
  const copyAndLinkEnabled = getFeatureFlag('pmAICopyLinkEnabled');
  let mountEl = document.getElementById('ai-copy-and-link-dialog');
  if (!mountEl) {
    mountEl = document.createElement('div');
    mountEl.setAttribute('id', 'ai-copy-and-link-dialog');
    document.body.appendChild(mountEl);
  }
  if (copyAndLinkEnabled && mountEl) {
    const root = createRoot(mountEl);
    root.render(
      <ErrorBoundary>
        <ThemeProvider>
          <ToastNotificationProvider>
            <GlobalConfigProvider>
              <AICopyStandaloneDialog
                id={id}
                initialData={initialData}
                onClose={() => root.unmount()}
              />
            </GlobalConfigProvider>
          </ToastNotificationProvider>
        </ThemeProvider>
      </ErrorBoundary>
    );
  }
};

window.aiCopyAndLink = aiCopyAndLink;
